import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/order/descending.js
// module id = 437
// module chunks = 0 1 2 3 4